import { RootState } from 'editor/src/store/index';

const getDesignCalendarConfigs = (state: RootState) => state.design.designData?.calendar || {};

export default getDesignCalendarConfigs;
